import React from 'react';
interface SectionProps {
  className?: string;
  children: React.ReactNode;
  id?: string;
  background?: 'cream' | 'white' | 'gray' | 'teal';
}
export function Section({
  className = '',
  children,
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-[#FFF9F5]',
    white: 'bg-white',
    gray: 'bg-gray-50',
    teal: 'bg-[#2C7A7B] text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-369">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-370">{children}</div>
    </section>;
}